import { Button } from '@/components/form/Button';
import { ButtonVariant } from '@/components/form/buttonHelper';
import { FC } from 'react';
import { useNavigate } from 'react-router';
import { LandingPageSection } from './LandingPageSection';
import { LandingPageStyle } from './landingPage.types';

export const AdminLandingPage: FC = () => {
  const navigate = useNavigate();

  return (
    <>
      <LandingPageSection
        color={LandingPageStyle.BLUE}
        imageUrl={'https://daasportal.app/wp-content/uploads/2023/06/DaaS-is-Different.webp'}
        title={'Configure Products'}
        stepNumber={1}
      >
        <p>Set prices and other details for products in the DaaS catalogue</p>
        <Button variant={ButtonVariant.Secondary} onClick={() => navigate(`configuratorCatalogue`)}>
          View The Catalogue
        </Button>
      </LandingPageSection>
      <LandingPageSection
        color={LandingPageStyle.ORANGE}
        imageUrl={'https://daasportal.app/wp-content/uploads/2023/04/DaaS-Portal-Work-from-home.jpg'}
        title={'Manage MSPS'}
        stepNumber={2}
      >
        <p>Configure details for MSPs in the system.</p>
        <Button variant={ButtonVariant.Secondary} onClick={() => navigate('msps/manageMsps')}>
          Go to MSPs page
        </Button>
      </LandingPageSection>
    </>
  );
};
